export default __webpack_public_path__ + "static/media/pagina_not_found.4f70b583.png";